import { NameAttribute } from '@personas/attributes/name.attribute'
import { WeightAttribute } from '@personas/attributes/weight.attribute'
import { PersonaFieldTypes } from '@personas/enums/persona-fields-types.enum'
import { PersonaFieldValues } from './persona-field-value.interface'
/**
 * Defines a persona field
 */
export interface PersonaField extends WeightAttribute, NameAttribute {
  /** Field type */
  form_element_type_id: PersonaFieldTypes
  /** Field label */
  label: string
  /** Is the field required? */
  is_required: number
  /** Is the field unique? */
  is_unique: boolean
  /** Is the field disabled in online registration? */
  is_disable_online: boolean
  /** Is the field disabled in onsite/crew registration? */
  is_disable_onsite: boolean
  /** Field allowed values (depends on field type) */
  form_element_values?: PersonaFieldValues
  /** Field metadata options - controls field behaviour */
  options?: PersonaFieldOptions
  /** Field id */
  id?: number
  /** Is the field titratable? */
  is_titratable?: boolean
}
/**
 * Further options for the persona field
 */
/** Font size for line separator fields */
export type LineSeparatorTextSize = 'small' | 'medium' | 'large'

export interface PersonaFieldOptions {
  /** List of available label translations */
  translations?: {
    [key: string]: string
  }
  /** Line separator font size */
  'text-size'?: LineSeparatorTextSize
  /** Metadata properties that accepts any kind */
  [key: string]: any
}
/** Defines persona field array */
export declare type PersonaFields = PersonaField[]

/** Defines a default empty persona field */
export const DEFAULT_PERSONA_FIELD: PersonaField = {
  weight: 0,
  form_element_type_id: null,
  label: '',
  name: '',
  is_required: 0,
  is_unique: false,
  is_disable_online: false,
  is_disable_onsite: false,
  form_element_values: [],
  id: 0,
  is_titratable: false
}
